import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  submit(event) {
    event.preventDefault();

    if(this.element.form != null) {
      this.element.form.requestSubmit();
    } else {
      this.element.requestSubmit();
    }
  }

  // For web components (e.g. <maui-input>) whose internal <input> lives in the
  // shadow DOM and is therefore not associated with the form: submit on Enter.
  // <maui-input> emits a `maui-keydown` custom event whose `detail.event` is the
  // originating native KeyboardEvent.
  submitOnEnter(event) {
    const key = event.detail?.event?.key ?? event.key;
    if (key !== "Enter") return;

    this.submit(event);
  }
}
